<div class="w-100 min-vh-100 bg-white-100 container-fluid" style="background-color: #f9fafc; padding-bottom: 15px ">
  <div class="pt-5 mx-md-4">
    <!-- FIRST -->
    <div class="card mb-3 p-3 shadow-lg">
      <div class="d-flex align-items-center justify-content-between flex-wrap" id="dashboard-header">
        <h2 class="mb-0">{{ activeRole }} Dashboard</h2>
        <div class="d-flex align-items-center gap-2" *ngIf="activeRole != 'Science Directors'">
          <input [(ngModel)]="searchTerm" id="search" type="text" class="form-control" placeholder="Quick Search..."
                 style="max-width: 200px;" (keydown.enter)="goToSearch()">
          <button class="btn d-flex align-items-center" id="searchBtn" (click)="goToSearch()">
            Search
            <span class="material-symbols-outlined ms-1" style="font-size: 1rem">search</span>
          </button>
        </div>
      </div>
    </div>

    <!-- HEADER -->
    <div class="row row-cols-1 row-cols-md-3 g-4">
      <div class="col">
        <div class="card dash-header shadow-lg">
          <div class="d-flex align-items-center">
              <span class="material-symbols-outlined me-3 dash-icon"
                    style="background-color: #2c7fff;">
                school
            </span>
            Number of Schools Participating
          </div>
          <div class="card-title text-center">{{ totalSchool }}</div>
        </div>
      </div>
      <div class="col">
        <div class="card dash-header shadow-lg">
          <div class="d-flex align-items-center">
              <span class="material-symbols-outlined me-3 dash-icon"
                    style="background-color: #00bc7d;">
                lab_profile
              </span>
            Total Annual School Profiles
          </div>
          <div class="card-title text-center">{{ totalAnnualSchools }}</div>
        </div>
      </div>
      <div class="col">
        <div class="card dash-header shadow-lg">
          <div class="d-flex align-items-center">
              <span class="material-symbols-outlined me-3 dash-icon"
                    style="background-color: #ac47ff;">
                folder
              </span>
            Total Projects
          </div>
          <div class="card-title text-center">{{ totalProject }}</div>
        </div>
      </div>
    </div>

    <!-- BUTTON GROUP-->
    <div class="mb-4">
      <div class="d-flex flex-wrap justify-content-between align-items-start gap-2">

        <!-- SECTION BUTTONS -->
        <div class="btn-group shadow-lg d-flex flex-wrap gap-2 flex-grow-1 flex-md-grow-0">
          <button type="button"
                  class="btn btn-custom me-2 mb-md-0"
                  [ngClass]="{ 'active': activeSection === 'overview' }"
                  (click)="setActive('overview')">
            Overview
          </button>

          <button type="button"
                  class="btn btn-custom me-2 mb-md-0"
                  [ngClass]="{ 'active': activeSection === 'annual' }"
                  (click)="setActive('annual')">
            Annual School Profiles
          </button>

          <button type="button"
                  class="btn btn-custom me-2 mb-md-0"
                  [ngClass]="{ 'active': activeSection === 'project' }"
                  (click)="setActive('project')">
            Projects
          </button>
        </div>

        <!-- FILTERS BUTTONS -->
        <div class="btn-group shadow-lg d-flex flex-wrap gap-2 justify-content-end flex-grow-1 flex-md-grow-0">
          <div class="me-2">
            <div class="ms-3">
              <button class="btn w-100 btn-custom" (click)="clearFilters()">
                CLEAR
              </button>
            </div>
          </div>

          <div *ngIf="activeRole !== 'GHS Teacher Representative' && activeRole !== 'Teacher'" class="me-2">
            <div class="dropdown ms-3">
              <button class="btn dropdown-toggle w-100 btn-custom" type="button"
                      [disabled]="isClusterLocked"
                      data-bs-toggle="dropdown" data-bs-auto-close="outside">
                {{ clusterDropdownText }}
              </button>
              <ul class="dropdown-menu dropdown-menu-fit">
                <li *ngFor="let cluster of clusterArray">
                  <label class="dropdown-item user-select-none">
                    <input class="form-check-input" type="checkbox" [value]="cluster"
                           [checked]="selectedClusters.includes(cluster)"
                           (change)="onClusterCheckedChanged($event, cluster)">
                    {{ cluster }}
                  </label>
                </li>
              </ul>
            </div>
          </div>

          <div class="me-2">
            <div class="dropdown ms-3">
              <button class="btn dropdown-toggle w-100 btn-custom" type="button"
                      data-bs-toggle="dropdown" data-bs-auto-close="outside">
                {{ schoolDropdownText }}
              </button>
              <ul class="dropdown-menu dropdown-menu-fit">
                <li *ngFor="let school of schoolArray">
                  <label class="dropdown-item user-select-none">
                    <input class="form-check-input" type="checkbox" [value]="school"
                           [checked]="selectedSchools.includes(school)"
                           (change)="onSchoolCheckedChanged($event, school)">
                    {{ school }}
                  </label>
                </li>
              </ul>
            </div>
          </div>

          <div class="me-2">
            <div class="dropdown ms-3">
              <button class="btn dropdown-toggle w-100 btn-custom" type="button"
                      data-bs-toggle="dropdown" data-bs-auto-close="outside">
                {{ yearDropdownText }}
              </button>
              <ul class="dropdown-menu dropdown-menu-fit">
                <li *ngFor="let year of yearArray">
                  <label class="dropdown-item user-select-none">
                    <input class="form-check-input" type="checkbox" [value]="year"
                           [checked]="selectedYear?.includes(year)"
                           (change)="onYearCheckedChanged($event, year)">
                    {{ year }}
                  </label>
                </li>
              </ul>
            </div>
          </div>

          <div *ngIf="activeRole !== 'GHS Teacher Representative' && activeRole !== 'Teacher'" class="me-2">
            <div class="dropdown ms-3">
              <button class="btn dropdown-toggle w-100 btn-custom" type="button"
                      data-bs-toggle="dropdown" data-bs-auto-close="outside">
                {{ teacherRepDropdownText }}
              </button>
              <ul class="dropdown-menu dropdown-menu-fit">
                <li *ngFor="let rep of teacherReps">
                  <button class="dropdown-item" type="button" (click)="selectTeacher(rep)">
                    {{ rep.fName }} {{ rep.lName }}
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div *ngIf="activeRole !== 'GHS Teacher Representative' && activeRole !== 'Teacher'" class="me-2">
            <div class="dropdown ms-3">
              <button class="btn dropdown-toggle w-100 btn-custom" type="button"
                      data-bs-toggle="dropdown" data-bs-auto-close="outside">
                {{ teacherDropdownText }}
              </button>
              <ul class="dropdown-menu dropdown-menu-fit">
                <li *ngFor="let teacher of teachers">
                  <button class="dropdown-item" type="button" (click)="selectTeacher(teacher)">
                    {{ teacher.fName }} {{ teacher.lName }}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- OVERVIEW -->
    <div id="overview-section" [hidden]="activeSection !== 'overview'">
      <div class="row g-3">
        <!-- TABLE -->
        <div class="col-12 col-lg-6">
          <div class="card shadow-lg h-100">
            <div class="px-3 pt-2 border-bottom">
              <div class="row">
                <div class="col-sm-12 px-3 py-2">
                  <div
                    class="d-flex flex-wrap flex-md-nowrap align-items-start align-items-md-center justify-content-between gap-2 mb-2">
                    <h5 class="fw-bolder mb-0">
                      {{ selectedMapCity ? (removeGASuffix(selectedMapCity) + " Schools") : "Schools / Cluster" }}
                    </h5>
                  </div>
                  <h6 class="opacity-75 text-secondary">
                    {{ selectedMapCity ? ("See information about " + removeGASuffix(selectedMapCity) + " Schools") : "See information about all schools" }}
                  </h6>
                </div>
              </div>
            </div>

            <div class="pt-0 px-0 d-flex flex-column justify-content-between" style="min-height: 390px;">
              <div class="table-responsive">
                <table class="table align-items-center mb-0 table-striped table-hover">
                  <thead>
                  <tr>
                    <th class="ps-3 py-2 text-uppercase text-secondary text-xxs fw-bolder opacity-75">
                      SCHOOL NAME
                    </th>
                    <th class="py-2 text-center text-uppercase text-secondary text-xxs fw-bolder opacity-75">
                      NUMBER OF STUDENTS
                    </th>
                  </tr>
                  </thead>

                  <tbody>
                  <tr *ngIf="!dashboardData">
                    <td><h6 class="mb-0">Loading...</h6></td>
                  </tr>
                  <tr *ngFor="let schoolData of schoolParticipationArray; trackBy: trackBySchool"
                      (click)="onSchoolRowClicked(schoolData.SchoolName)"
                      [ngClass]="{'text-muted': selectedSchool && selectedSchool !== schoolData.SchoolName}">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">
                            {{ schoolData.SchoolName.endsWith('School') ? schoolData.SchoolName : schoolData.SchoolName + ' School' }}
                          </h6>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-xs">{{ schoolData.studentCount | number:'1.0-0' }}</span>
                    </td>
                  </tr>
                  </tbody>

                </table>
              </div>

              <nav class="d-flex justify-content-center pt-3">
                <ul *ngIf="paginatedPages.length > 1" class="pagination pagination-sm">

                  <li (click)="prevPage(); $event.preventDefault()" class="page-item">
                    <a class="page-link" href="#">Prev</a>
                  </li>

                  <li (click)="goToPage(0); $event.preventDefault()"
                      [ngClass]="{ 'active': currentTablePage === 0 }"
                      class="page-item">
                    <a class="page-link" href="#">1</a>
                  </li>

                  <li *ngIf="currentTablePage > 2" class="page-item disabled">
                    <a class="page-link">...</a>
                  </li>

                  <ng-container *ngFor="let page of paginatedPages; let i = index">
                    <ng-container *ngIf="i > 0 && i < paginatedPages.length - 1">
                      <li *ngIf="Math.abs(currentTablePage - i) <= 1"
                          (click)="goToPage(i); $event.preventDefault()"
                          [ngClass]="{ 'active': currentTablePage === i }"
                          class="page-item">
                        <a class="page-link" href="#">{{ i + 1 }}</a>
                      </li>
                    </ng-container>
                  </ng-container>

                  <li *ngIf="currentTablePage < paginatedPages.length - 3" class="page-item disabled">
                    <a class="page-link">...</a>
                  </li>

                  <li (click)="goToPage(paginatedPages.length - 1); $event.preventDefault()"
                      [ngClass]="{ 'active': currentTablePage === paginatedPages.length - 1 }"
                      class="page-item">
                    <a class="page-link" href="#">{{ paginatedPages.length }}</a>
                  </li>

                  <li (click)="nextPage(); $event.preventDefault()" class="page-item">
                    <a class="page-link" href="#">Next</a>
                  </li>

                </ul>

              </nav>

            </div>
          </div>
        </div>

        <!-- MAP -->
        <div class="col-12 col-lg-6">
          <div id="map" class="h-100 w-100 border rounded" style="min-height: 390px;"></div>
        </div>
      </div>
    </div>

    <!-- ANNUAL SCHOOL PROFILES -->
    <div id="annual-section" *ngIf="activeSection === 'annual'">
      <div class="row row-cols-1 row-cols-md-3 g-4">
        <div class="col">
          <div class="card shadow-lg annual-cards">
            <div class="card-title"><h5>Total Students</h5></div>
            <div class="card-body text-center">{{ totalAnnualStudents }}</div>
            <div class="card-subtitle text-muted">Across {{ totalAnnualSchools }} annual school profiles</div>
          </div>
        </div>
        <div class="col">
          <div class="card shadow-lg annual-cards">
            <div class="card-title"><h5>Total Staff</h5></div>
            <div class="card-body text-center">{{ totalAnnualStaffs }}</div>
            <div class="card-subtitle text-muted">Teachers & Staff</div>
          </div>
        </div>
        <div class="col">
          <div class="card shadow-lg annual-cards">
            <div class="card-title"><h5>Student-Staff Ratio</h5></div>
            <div class="card-body text-center">{{ annualRatio }}</div>
            <div class="card-subtitle text-muted">Average across district</div>
          </div>
        </div>
      </div>

      <div class="card shadow-lg mb-4">
        <h5>Enrollment By School</h5>
        <div class="d-flex justify-content-center overflow-auto">
          <canvas baseChart
                  [datasets]="annualRatioData.datasets"
                  [labels]="annualRatioData.labels"
                  [options]="annualRatioOption"
                  [type]="'bar'"
                  style="width: 100%; max-width: 100%; min-height: 50vh; height: auto;">
          </canvas>
        </div>
      </div>


      <div class="card shadow-lg">
        <h5>Environmental Education Goals by School</h5>
        <div class="card-subtitle mb-4">
          Number of schools that selected each environmental category as a focus area
        </div>

        <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
          <div class="col">
            <app-dashboard-annual-section
              title="Food Waste"
              [value]="totalAnnualFoodWaste"
              subtitle="schools"
              icon="grocery"
              iconColor="#12b981"
              iconBg="#e6f6ef"
              borderColor="#12b981">
            </app-dashboard-annual-section>
          </div>

          <div class="col">
            <app-dashboard-annual-section
              title="Gardens"
              [value]="totalAnnualGardens"
              subtitle="schools"
              icon="local_florist"
              iconColor="#84cc15"
              iconBg="#f1f7e4"
              borderColor="#84cc15">
            </app-dashboard-annual-section>
          </div>

          <div class="col">
            <app-dashboard-annual-section
              title="Water"
              [value]="totalAnnualWater"
              subtitle="schools"
              icon="water_drop"
              iconColor="#02b6d3"
              iconBg="#e6f5fa"
              borderColor="#02b6d3">
            </app-dashboard-annual-section>
          </div>

          <div class="col">
            <app-dashboard-annual-section
              title="Recycling"
              [value]="totalAnnualRecycling"
              subtitle="schools"
              icon="recycling"
              iconColor="#3a82f6"
              iconBg="#e8eefe"
              borderColor="#3a82f6">
            </app-dashboard-annual-section>
          </div>

          <div class="col">
            <app-dashboard-annual-section
              title="Energy"
              [value]="totalAnnualEnergy"
              subtitle="schools"
              icon="electric_bolt"
              iconColor="#f49e0b"
              iconBg="#fdf2e4"
              borderColor="#f49e0b">
            </app-dashboard-annual-section>
          </div>

          <div class="col">
            <app-dashboard-annual-section
              title="Other"
              [value]="totalAnnualOther"
              subtitle="schools"
              icon="more_horiz"
              iconColor="#8b5cf5"
              iconBg="#f0eaff"
              borderColor="#8b5cf5">
            </app-dashboard-annual-section>
          </div>
        </div>
      </div>

    </div>

    <!-- PROJECT -->
    <div id="project-section" *ngIf="activeSection === 'project'">
      <div class="row row-cols-1 row-cols-md-3 g-4">
        <div class="col">
          <app-dashboard-project-section
            title="Food Waste Programs"
            icon="grocery"
            iconBg="#e6f6ef"
            iconColor="#12b981"
            [studentValue]="totalStudentsInFoodWasteProject"
            [teacherValue]="totalTeachersInFoodWasteProject">
          </app-dashboard-project-section>
        </div>
        <div class="col">
          <app-dashboard-project-section
            title="Garden Programs"
            icon="local_florist"
            iconBg="#f1f7e4"
            iconColor="#84cc15"
            [studentValue]="totalStudentsInGardenProject"
            [teacherValue]="totalTeachersInGardenProject">
          </app-dashboard-project-section>
        </div>
        <div class="col">
          <app-dashboard-project-section
            title="Water Programs"
            icon="water_drop"
            iconBg="#e6f5fa"
            iconColor="#02b6d3"
            [studentValue]="totalStudentsInWaterProject"
            [teacherValue]="totalTeachersInWaterProject">
          </app-dashboard-project-section>
        </div>
      </div>

      <div class="card shadow-lg mb-4" style="background-color: var(--paleblue)">
        <div class="card-title mb-3">School Participation Overview</div>
        <div class="row row-cols-md-4">
          <div class="col mb-4">
            <div class="card">
              <div class="card-title">Schools Participating</div>
              <div class="card-body">{{ totalSchoolParticipatingInProject }} / {{ totalSchool }}</div>
              <div class="card-subtitle text-muted">{{ percentageOfSchoolParticipatingInProject }}% participating rate
              </div>
            </div>
          </div>
          <div class="col mb-4">
            <div class="card">
              <div class="card-title">Food Waste Programs</div>
              <div class="card-body">{{ foodWasteSchoolParticipation }} / {{ totalSchoolParticipatingInProject }}</div>
              <div class="card-subtitle text-muted">{{ foodWasteParticipationPercentage }}% participating rate</div>
            </div>
          </div>
          <div class="col mb-4">
            <div class="card">
              <div class="card-title">Garden Programs</div>
              <div class="card-body">{{ gardenSchoolParticipation }} / {{ totalSchoolParticipatingInProject }}</div>
              <div class="card-subtitle text-muted">{{ gardenParticipationPercentage }}% participating rate</div>
            </div>
          </div>
          <div class="col mb-4">
            <div class="card">
              <div class="card-title">Water Programs</div>
              <div class="card-body">{{ waterSchoolParticipation }} / {{ totalSchoolParticipatingInProject }}</div>
              <div class="card-subtitle text-muted">{{ waterParticipationPercentage }}% participating rate</div>
            </div>
          </div>
        </div>

      </div>

      <div class="row row-cols-1 g-3">
        <div class="col">
          <div class="card shadow-lg">
            <h4>Projects by Category</h4>
            <div>
              <canvas baseChart
                      [data]="projectGrowthByYearData"
                      [options]="projectGrowthByYearOptions"
                      [type]="'line'"
                      style="width: 100%; height: 300px;">
              </canvas>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

